/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MenuItemRating
 */
export interface MenuItemRating {
    /**
     * 
     * @type {number}
     * @memberof MenuItemRating
     */
    rating: number;
}

/**
 * Check if a given object implements the MenuItemRating interface.
 */
export function instanceOfMenuItemRating(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "rating" in value;

    return isInstance;
}

export function MenuItemRatingFromJSON(json: any): MenuItemRating {
    return MenuItemRatingFromJSONTyped(json, false);
}

export function MenuItemRatingFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuItemRating {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rating': json['rating'],
    };
}

export function MenuItemRatingToJSON(value?: MenuItemRating | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rating': value.rating,
    };
}

